import { render } from "./productPageBrand.vue?vue&type=template&id=4bf2b37e"
import script from "./productPageBrand.vue?vue&type=script&lang=js"
export * from "./productPageBrand.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__